import { css } from "emotion";

import { breakpoints, icons } from "@cobliteam/base-components";

export const overlayTitle = css`
  margin: 20px 20px 30px;
`;

export const optionsContainerScroll = () => {
  const actionButtonsHeight = 70;
  const clearFilterHeight = 60;
  const optionsContainerHeight = 135;
  const bottomMargin = 130;
  const occupiedHeightExcludingScroll = `${
    actionButtonsHeight +
    clearFilterHeight +
    bottomMargin +
    optionsContainerHeight
  }px`;

  return css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-height: calc(100vh - ${occupiedHeightExcludingScroll});
    min-height: ${optionsContainerHeight}px;
    width: 100%;
    overflow-y: auto;
  `;
};

export const optionsContainer = css`
  margin: 0 30px;
`;

export const clearFilterButton = css`
  && {
    max-width: 90px;
    margin: 20px;
    justify-content: flex-start;
  }
`;

export const filterActions = css`
  display: flex;
  justify-content: space-between;
  margin: 20px;
`;

export const icon = css`
  height: ${icons.size.small};
  margin-right: 10px;

  & > svg {
    font-size: ${icons.size.small};
  }
`;

export const overlay = css`
  display: flex;
  flex-direction: column;
  min-width: 410px;
  box-sizing: border-box;
  margin: 5px 0;

  @media screen and (max-width: ${breakpoints.tablet}) {
    width: 410px;
  }
`;

export const cancelButton = css`
  && {
    margin-right: 40px;
    margin-left: auto;
  }
`;
